// Action types for UI
export const ADD_NINJA_DIALOG_OPEN = 'ADD_NINJA_DIALOG_OPEN';
export const ADD_NINJA_DIALOG_CLOSE = 'ADD_NINJA_DIALOG_CLOSE';
export const ADD_NINJA_DIALOG_FORM = 'ADD_NINJA_DIALOG_FORM';
export const UPDATE_NINJA_DIALOG_FORM = 'UPDATE_NINJA_DIALOG_FORM';




/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/add-ninja-dialog/action-types.js
 **/